// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"13f04ceaa5221158","5763":"8894a02769e41b00","6893":"dbf6da512a52cd4e","6974":"110f164f18302879","7222":"90a576a0a6051b28","7937":"987d18ae9f07b45f"}[chunkId] + ".js";
};